

document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('.hero-swiper-autodealers');
    if (!el) return;

    const swiperVertical = new Swiper(el, {
        direction: 'vertical',
        slidesPerView: 1,
        speed: 700,
        loop: false,

        pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
        },

        mousewheel: {
            forceToAxis: true,
            thresholdDelta: 8,
            thresholdTime: 200,
            releaseOnEdges: true,
        },

        resistanceRatio: 0.6,
    });

    const section = el.closest('.section-slider-vertical');
    if (section) {
        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    swiperVertical.mousewheel.enable();
                } else {
                    swiperVertical.mousewheel.disable();
                }
            });
        }, { threshold: 0.6 });

        io.observe(section);
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/pinned-slider.js